<template>
  <div class="shade-chil" @click.stop="unSelect()">
    
    <i class="iconfont resource-icon">&#xe6ff;</i>
    <h1 class="resource-title">{{$t('message.图片资源库')}}</h1>
    <div style="height: 578px border-bottom: 1px solid #ddd">
      <div class="resource">
        <div class="seek-box">
          <el-input
            type="text"
            :placeholder="$t('message.请输入搜索内容')"
            v-model="searchContent"
            class="seek-main"
            @keyup.enter.native="doSearch()"
          />
          <i class="iconfont seek-icon" @click="doSearch()">&#xe7b4;</i>
        </div>
        <div class="listBtn-box">
          <span>
            <i class="iconfont" >&#xe765;</i>
            <a href="javascript:" @click="onLoad()">{{$t('message.根目录')}}</a>
          </span>
          <span>
            <i class="iconfont" v-if="parentData && parentData.parentID != '0'">&#xe72c;</i>
            <a
              href="javascript:"
              v-if="parentData && parentData.parentID != '0'"
              @click="openDirectory(parentData.parentID)">...</a>
            <i
              class="iconfont"
              v-if="currentData && currentData.parentID != '0'"
              >&#xe72c;</i>
            <a
              href="javascript:"
              v-if="currentData && currentData.parentID != '0'"
              @click="openDirectory(currentData.parentID)"
              >{{ parentData.name }}</a>
            <i class="iconfont" v-if="currentData">&#xe72c;</i>
            <a href="javascript:" v-if="currentData" @click="openDirectory(currentData.directoryID)">{{ currentData.name }}</a>
            <span v-if="searchResultShow">
              <i class="iconfont">&#xe72c;</i>
              <a href="javascript:" @click="onLoad">{{$t('message.搜索结果')}}</a>
            </span>
          </span>
        </div>
        <div class="state-box">
          <el-upload
            name="attachment"
            class="upload-demo"
            action="/manage/resource/uploadresource"
            :headers="sessionHeaders"
            :data="{
              appid: appID,
              directoryid: currentData ? currentData.directoryID : '0',
            }"
            :show-file-list="false"
            multiple
            :limit="100"
            :on-exceed="handleExceed"
            :on-success="handleAvatarSuccess"
            :on-error="upError"
            :before-upload="beforeAvatarUpload"
            :file-list="fileList"
            :on-change="onUploadChange"
            :on-remove="onUploadRemove"
          >
            <a href="javascript:"><i class="iconfont">&#xe788;</i>{{$t('message.上传')}}</a>
          </el-upload>
          <a href="javascript:" class="link-btn" @click.stop="createDirectoryTemp()">
            <i class="iconfont">&#xe642;</i> {{$t('message.创建文件夹')}}</a>
          <a href="javascript:" class="link-btn" @click.stop="onRename()">
            <i class="iconfont">&#xe618;</i> {{$t('message.重命名')}}</a>
          <a href="javascript:" class="link-btn" @click.stop="onMoveTo()">
            <i class="iconfont">&#xe62a;</i> {{$t('message.移动')}}</a>
          <!--@click.stop="deleteFile"-->
          <a
            href="javascript:"
            class="link-btn"
            @click.stop="onDelete">
            <i class="iconfont">&#xe637;</i> {{$t('message.删除')}}
          </a>
          <a
            href="javascript:"
            class="link-btn"
            @click.stop="refresh(currentData ? currentData.directoryID : '0', 1)"
          >
            <i class="iconfont">&#xe667;</i> {{$t('message.刷新')}}
          </a>
          <a href="javascript:" class="link-btn" @click.stop="onPreview()">
            <i class="iconfont" style="font-size: 19px">&#xe67d;</i> {{$t('message.图片预览')}}
          </a>
        </div>
        <div id="resourceList"
          class="resourceList" 
          v-loading="loadingFlag"
          :element-loading-text="$t('message.拼命加载中')"
          element-loading-spinner="el-icon-loading">
          <div
            class="file"
            v-for="(item, index) in directoryDatas"
            :key="item.id"
            @dblclick.stop="openDirectory(item.directoryID)"
            @click.stop="
              selectFile(
                1,
                index,
                item.directoryID,
                item.name,
                item.contentType,
                item.create_at
              )
            "
            :class="{
              fileColor: (selectedType == 1 && selectedDIRIndex == index),
            }"
          >
            <i class="iconfont fileIcon">&#xe614;</i>
            <textarea
              wrap="soft|hard"
              class="renameTextArea"
              v-if="renameFlag && selectedType == 1 && selectedDIRIndex == index"
              v-model="selectedName"
              @blur.stop="doRename"
              @keyup.enter.stop="doRename"
              ref="renameArea"
            />
            <p class="myipt" :class="{
                myiptSelected: selectedType == 1 && selectedDIRIndex == index,
              }" v-else>{{ item.name }}</p>
          </div>
          <div
            v-for="(item, index) in imgDatas"
            :key="index"
            class="fileImg"
            :class="{
              fileColor: (selectedType == 2 && selectedIMGIndex == index)||(item.url&&iteminmulti(item.url)!=-1),
            }"
            @dblclick.stop="onPreviewChange(index); onPreview();"
            @click.stop="
              selectFile(
                2,
                index,
                item.directoryID,
                item.name,
                item.url,
                item.create_at,
                item.size
              )
            "
          >
            <div>
              <img v-if="item.isMovieFile"
                :src="'../../../static/images/mp4.png'"
                :alt="item.contentType"
              />
              <img v-if="item.contentType=='application/pdf'"
                :src="'../../../static/images/pdf.png'"
                :alt="item.contentType"
              />
              <img v-else
                :src="'/rs/tbimg?resourceid=' + item.resourceID"
                :alt="item.contentType"
              />
            </div>
            <textarea
              wrap="soft|hard"
              class="renameTextArea"
              v-if="renameFlag && selectedType == 2 && selectedIMGIndex == index"
              v-model="selectedName"
              @blur.stop="doRename"
              @keyup.enter.stop="doRename"
              ref="renameArea"
            />
            <p class="imgP myipt" :class="{
                myiptSelected: selectedType == 2 && selectedIMGIndex == index,
              }" v-else>{{ item.name }}</p>
          </div>
        </div>

        <el-dialog
          :title="$t('message.创建文件夹')"
          :visible.sync="createDirDialogVisible"
          width="400px"
          :modal="false"
          center
          :before-close="handleClose"
        >
          <textarea
              wrap="soft|hard"
              class="renameTextAreaDialog"
              v-model="tempDirectoryData"
              :placeholder="$t('message.请入文件夹名称')"
              @keyup.enter.stop="createDirectory"
            />
          <span slot="footer" class="dialog-footer">
            <el-button @click="createDirDialogVisible = false; tempDirectoryData = null;">{{$t('message.取消')}}</el-button>
            <el-button type="primary" @click.native="createDirectory">{{$t('message.创建')}}</el-button>
          </span>
        </el-dialog>

        <el-dialog
          :title="$t('message.删除确认')"
          :visible.sync="deleteDialogVisible"
          width="400px"
          :modal="false"
          center
          :before-close="handleClose"
        >
          <span>{{$t('message.点击删除将文件移入回收站')}}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="deleteDialogVisible = false">{{$t('message.取消')}}</el-button>
            <el-button type="primary" @click.native="deleteFile">{{$t('message.删除')}}</el-button>
          </span>
        </el-dialog>

        <el-dialog
          :title="$t('message.选择目标文件夹')"
          :visible.sync="moveToDialogVisible"
          width="600px"
          :modal="false"
          center
          :before-close="handleClose"
        >
          <el-tree
            :data="treeData"
            :props="defaultProps"
            accordion
            node-key="value"
            :default-expanded-keys="['0']"
            :highlight-current="true"
            :expand-on-click-node="false"
            style="height:500px; overflow:auto;"
            @node-click="handleCheckChangeArea">
          </el-tree>
          <!-- show-checkbox
            :check-on-click-node="true"
            :check-strictly="true" -->
          <!-- @node-click="handleNodeClick" -->
          <span slot="footer" class="dialog-footer">
            <el-button @click="moveToDialogVisible = false">{{$t('message.取消')}}</el-button>
            <el-button type="primary" @click.native="doMoveTo">{{$t('message.移动')}}</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <div class="progress" v-if="RAMInfo">
      
      <el-progress
        class="progressbar"
        :text-inside="false"
        :show-text="false"
        :stroke-width="15"
        :percentage="usersRAM"
        :status="usersRAM > 80 ? 'exception' : 'success'"
      ></el-progress>
      <div style="font-size:12px;position:relative;width:180px;display:flex;justify-content:space-between;"><span>{{$t('message.容量')}}</span><span style="text-align:right;line-height:15px;padding:2px">{{ usedRam +'/'}}{{ maxRam }}</span> </div>
    </div>
    <div class="myObject">
      {{ directoryDatas.length + imgDatas.length +$t('message.个项目')}}
    </div>
    <div class="myDate" v-if="selectedType">
      <p v-if="selectedType == 1"><span>{{ information.type }}</span></p>
      <p v-if="selectedType == 2"><span>{{ information.type }}：{{ information.wh }}&nbsp;&nbsp;({{ information.size }})</span></p>
      <p>
        <!-- <span>{{ information.name }}</span> -->
        <span v-if="information.create_at">{{$t('message.创建日期')+ information.create_at }}&nbsp;&nbsp;by&nbsp;{{ information.createrName }}</span>
      </p>
      <p></p>
    </div>
    <div class="on-btn">
      <el-button type="" size="mini" @click="onButtonClick" round
        >{{$t('message.关闭')}}</el-button
      >
      <el-button type="primary" size="mini" @click="onButtonClick(1)" round
        >{{$t('message.选择')}}</el-button
      >
    </div>
    <div class="zheZhao" v-if="previewShow" @click.stop="">
      <i class="iconfont exit" @click="previewShow = false">&#xe635;</i>

      <div class="content-img">
        <el-carousel
          arrow="always"
          :autoplay="false"
          indicator-position="none"
          @change="onPreviewChange"
          :initial-index="selectedIMGIndex"
          height="600px"
        >
          <el-carousel-item v-for="(item, index) in imgDatas" :key="index">
            <video v-if="item.isMovieFile" width="480" height="320" controls class="myImg">
              <source :src="item.url" type="video/mp4">
              您的浏览器不支持 HTML5 video 标签。
            </video>
            <iframe v-if="item.contentType=='application/pdf'" width="100%" height="100%"
              :src="item.url"
            ></iframe>
            <img v-else
              :src="item.url"
              class="myImg"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
      <transition name="fade">
        <div class="count-img" v-show="countShow">
          {{ selectedIMGIndex + 1 }} / {{ imgDatas.length }}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import { PopupManager } from "element-ui/lib/utils/popup";
import shade from "@/components/shade/shade";
import commonUtil from "@/utils/commonUtil";
import { confirmmy } from "@/utils/minxins";
export default {
  name: "resourceStore",
  props: {
    shadeShow: {
      type: Boolean,
    },
    appID: {
      type: String,
    },
  },
  components: {
    shade,
  },
  data() {
    return {
      createDirDialogVisible: false,
      deleteDialogVisible: false,
      moveToDialogVisible: false,
      searchResultShow: false,
      searchContent: "",
      renameFlag: false,
      imgDatas: [],
      directoryDatas: [],
      tempDirectoryData: null,
      parentData: "",
      currentData: null,
      fileShow: {},
      RAMInfo: "",
      selectedName: null,
      selectedDIRIndex: null,
      selectedIMGIndex: null,
      selectedType: null, // 1.选中文件夹 2.选中图片
      information: null, // 图片信息
      previewShow: false, // 预览图 显示状态
      countShow: true,
      cler: null,
      treeData: null,
      treeServerData: null,
      moveToTargetID: null,
      defaultProps: {
        children: "children",
        label: "label",
        isLeaf: "leaf",
        value: null,
      },
      loadingFlag: true,
      fileList: [],
      multiselect:[]
    };
  },
  methods: {
    onSelectImg(index, url) {
      // 选择图片
      this.indexImg = index;
    },
    onPreviewChange(index) {
      window.clearTimeout(this.cler);
      this.countShow = true;
      this.selectedIMGIndex = index;
      this.cler = window.setTimeout(() => {
        this.countShow = false;
      }, 4000);
    },
    onPreview() {
      this.previewShow = true;
    },
    onButtonClick(id) {
      if (id === 1) {
        if (this.selectedType != 2&&!this.multiselect.length) {
          confirmmy(this, {
            title: this.$t("message.您还未选择任何图片"),
            iscancel: false,
            isprop: false,
          });
          //   this.$message({
          //   type: "warning",
          //   message: this.$t("message.您还未选择任何图片"),
          // });
        } else {
          console.log(this.information.url,this.multiselect)
          this.$emit("onClick", { resourceID: this.information.url?this.information.url:this.multiselect[0].url ,multiselect:this.multiselect});
        }
      } else {
        this.$emit("onClick", null);
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    upError(err, file, fileList) {
      // 上传失败钩子
      console.log(err);
    },

    handleAvatarSuccess(res, file) {
      console.log(res);
      if (res.Code != "MSGKEY_OK") {
        confirmmy(this, {
          title: res.Message + ":" + res.data.errorMsg,
          iscancel: false,
          isprop: false,
        });
      } else {
        // confirmmy(this, {
        //   title: "upload success.",
        //   iscancel: false,
        //   isprop: false,
        // });
        this.imageUrl = window.URL.createObjectURL(file.raw);
        this.openDirectory(
          this.currentData ? this.currentData.directoryID : "0"
        );
      }
    },
    handleExceed() {
      confirmmy(this, {
        title: this.$t("message.每次最多上传100个文件"),
        iscancel: false,
        isprop: false,
      });
      // this.$message({
      //     type: "warning",
      //     message: this.$t("message.每次最多上传100个文件"),
      //   });
    },
    beforeAvatarUpload(file) {
      let isJPG = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/gif"
      ) {
        isJPG = true;
      }

      console.log(file.type);
      console.log(isJPG);

      let isVedio = false;
      if (file.type === "video/mp4") {
        isVedio = true;
      }

      let isPdf = false;
      if (file.type == "application/pdf") {
        isPdf = true;
      }

      if (!isJPG && !isVedio && !isPdf) {
        confirmmy(this, {
          title: this.$t("message.上传图片格式"),
          iscancel: false,
          isprop: false,
        });
        // this.$message({
        //   type: "error",
        //   message: this.$t("message.上传图片格式"),
        // });
      }
      let isLt20M = false;
      if (isJPG) {
        isLt20M = file.size / 1024 < 20480;

        if (!isLt20M) {
          confirmmy(this, {
            title: this.$t("message.上传图片大小"),
            iscancel: false,
            isprop: false,
          });
          //   this.$message({
          //   type: "error",
          //   message: this.$t("message.上传图片大小"),
          // });
        }
      }
      console.log(isJPG);

      return (isJPG && isLt20M) || isVedio || isPdf;
    },
    createDirectory() {
      if (this.tempDirectoryData == null) {
        return;
      }
      if (this.tempDirectoryData.replace(/[\r\n]/g, "") == "") {
        this.tempDirectoryData = "new folder";
      }
      // 创建文件夹
      rejecthttp(
        true,
        "post",
        "/manage/resource/adddirectory",
        {
          appid: this.appID,
          parentdireid: this.currentData ? this.currentData.directoryID : "0",
          name: this.tempDirectoryData.replace(/[\r\n]/g, ""),
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.openDirectory(
              this.currentData ? this.currentData.directoryID : "0"
            );
          }
        }
      );
     
      this.tempDirectoryData = null;
      this.createDirDialogVisible = false;
    },
    createDirectoryTemp() {
      // 创建文件
      this.tempDirectoryData = "";
      this.createDirDialogVisible = true;
    },
    refresh(ID) {
      this.parentData = null;
      this.currentData = null;
      this.directoryDatas = [];
      this.imgDatas = [];
      window.setTimeout(() => {
        this.openDirectory(ID);
      }, 100);
    },

    // 进入目录
    openDirectory(ID) {
      this.loadingFlag = true;
      rejecthttp(
        false,
        "get",
        "/manage/resource/opendirectory",
        {
          appid: this.appID,
          directoryid: ID,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          this.loadingFlag = false;
          if (doc.data.Code == "MSGKEY_OK") {
            this.parentData =
              doc.data.data.parentInfo != null ? doc.data.data.parentInfo : 0;
            this.currentData = doc.data.data.currentData;
            this.directoryDatas = doc.data.data.directoryList;
            if (!this.directoryDatas) this.directoryDatas = {};
            this.imgDatas = doc.data.data.resourceList; // 图片
            if (!this.imgDatas) this.imgDatas = {};
            this.RAMInfo = doc.data.data.storeInfo;
            this.unSelect();
          }
        }
      );
     
    },
    // 初始化目录
    onLoad() {
      this.loadingFlag = true;
      rejecthttp(
        false,
        "get",
        "/manage/resource/opendirectory",
        {
          appid: this.appID,
          directoryid: "0",
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          this.loadingFlag = false;
          if (doc.data.Code == "MSGKEY_OK") {
            this.directoryDatas = doc.data.data.directoryList;
            if (!this.directoryDatas) this.directoryDatas = {};
            this.imgDatas = doc.data.data.resourceList;
            if (!this.imgDatas) this.imgDatas = {};
            this.currentData = "";
            this.parentData = "";
            this.searchResultShow = false;
            this.RAMInfo = doc.data.data.storeInfo;
          }
        }
      );
     
    },
    onRename() {
      if (this.selectedType) {
        this.renameFlag = true;
      } else {
        confirmmy(this, {
          title: this.$t("message.您还未选择任何项目"),
          iscancel: false,
          isprop: false,
        });
        
      }
    },
    doRename() {
      this.renameFlag = false;
      if (!this.selectedName || this.selectedName.replace(/[\r\n]/g, "") == "")
        return;
      if (this.selectedType == 1) {
        rejecthttp(
          true,
          "post",
          "/manage/resource/renamedirectory",
          {
            appid: this.appID,
            directoryid: this.directoryDatas[this.selectedDIRIndex].directoryID,
            newname: this.selectedName.replace(/[\r\n]/g, ""),
          },
          this,
          (doc) => {
            changeflagCLOSED(doc, 0, this);
            if (doc.data.Code == "MSGKEY_OK") {
              this.openDirectory(
                this.currentData ? this.currentData.directoryID : "0"
              );
            }
          }
        );
        
      } else if (this.selectedType == 2) {
        rejecthttp(
          true,
          "post",
          "/manage/resource/renameresource",
          {
            appid: this.appID,
            resourceid: this.imgDatas[this.selectedIMGIndex].resourceID,
            newname: this.selectedName.replace(/[\r\n]/g, ""),
          },
          this,
          (doc) => {
            changeflagCLOSED(doc, 0, this);
            if (doc.data.Code == "MSGKEY_OK") {
              this.openDirectory(
                this.currentData ? this.currentData.directoryID : "0"
              );
            }
          }
        );
        
      }
    },
    onDelete() {
      if (this.selectedType) {
        this.deleteDialogVisible = true;
      } else {
        confirmmy(this, {
          title: this.$t("message.您还未选择任何项目"),
          iscancel: false,
          isprop: false,
        });
        
      }
    },
    deleteFile() {
      // 文件删除
      if (this.selectedType == 1) {
        rejecthttp(
          true,
          "post",
          "/manage/resource/deletedirectory",
          {
            appid: this.appID,
            directoryid: this.directoryDatas[this.selectedDIRIndex].directoryID,
          },
          this,
          (doc) => {
            changeflagCLOSED(doc, 0, this);
            if (doc.data.Code == "MSGKEY_OK") {
              this.successMsgBox(doc.data.Message);
              this.openDirectory(
                this.currentData ? this.currentData.directoryID : "0"
              );
            }
          }
        );
        
      } else if (this.selectedType == 2) {
        rejecthttp(
          true,
          "post",
          "/manage/resource/deleteresource",
          {
            appid: this.appID,
            resourceid: this.imgDatas[this.selectedIMGIndex].resourceID,
          },
          this,
          (doc) => {
            changeflagCLOSED(doc, 0, this);
            if (doc.data.Code == "MSGKEY_OK") {
              this.successMsgBox(doc.data.Message);
              this.openDirectory(
                this.currentData ? this.currentData.directoryID : "0"
              );
            }
          }
        );
       
      }
      this.deleteDialogVisible = false;
    },
    selectmorefile(type, index, ID, name, url, date, size){
      console.log(this.multiselect)
      if(type==1){
        console.log('不能选中文件夹')
        this.multiselect=[]
        // return 
      }
      let i=this.multiselect.findIndex(item=>item.url==url)
      if(i==-1){
        this.multiselect.push({url:url,name:name})
        return true
      }else{
        this.multiselect.splice(i,1)
        return false
      }
    },
    iteminmulti(url){
      let i=this.multiselect.findIndex(item=>item.url==url)
      return i
    },
    // 选择文件
    selectFile(type, index, ID, name, url, date, size) {
      let c=this.selectmorefile(type, index, ID, name, url, date, size)
      if(!c){
        this.information = {
            name: '',
            type: "",
            create_at: '',
            creater: '',
            createrName: '',
            size: '',
            url: '',
            wh:
              '',
          };
          this.renameFlag = false;
          this.selectedType = '';
          this.selectedName = '';
          this.selectedIMGIndex = -1;
        return
      }
      if (type == 1) {
        if (this.selectedType == 1 && this.selectedDIRIndex === index) {
          if (this.renameFlag == false) {
            // this.selectedType = null;
            // this.selectedName = null;
            // this.selectedDIRIndex = null;
          }
        } else {
          this.information = {
            name: name,
            type: "文件夹",
            create_at: commonUtil.formatDate(date),
            creater: this.directoryDatas[index].creater,
            createrName: this.directoryDatas[index].createrName,
            size: "",
            wh: "",
          };
          this.renameFlag = false;
          this.selectedType = 1;
          this.selectedName = name;
          this.selectedDIRIndex = index;
        }
      } else if (type == 2) {
        if (this.selectedType == 2 && this.selectedIMGIndex === index) {
          if (this.renameFlag == false) {
            // this.selectedType = null;
            // this.selectedName = null;
            // this.selectedIMGIndex = null;
          }
        } else {
          this.information = {
            name: name,
            type: "图片尺寸",
            create_at: commonUtil.formatDate(date),
            creater: this.imgDatas[index].creater,
            createrName: this.imgDatas[index].createrName,
            size: commonUtil.formatRam(size),
            url: url,
            wh:
              this.imgDatas[index].width + " x " + this.imgDatas[index].height,
          };
          this.renameFlag = false;
          this.selectedType = 2;
          this.selectedName = name;
          this.selectedIMGIndex = index;
        }
      }
    },
    successMsgBox(text) {
      // 正常提示框
      this.$message({
        message: text,
        type: "success",
      });
    },
    warningMsgBox(text) {
      // 警告提示框
      this.$message({
        message: text,
        type: "warning",
      });
    },
    unSelect() {
      // 去除选中
      if (this.deleteDialogVisible == true) return;
      if (this.renameFlag == true) return;
      this.selectedType = null;
      this.selectedName = null;
      this.selectedDIRIndex = null;
      this.selectedIMGIndex = null;
      this.selectFileID = 0;
    },
    doSearch() {
      if (this.searchContent == "") {
        this.onLoad();
        return;
      }
      rejecthttp(
        true,
        "get",
        "/manage/resource/search",
        {
          appid: this.appID,
          content: this.searchContent,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.parentData = null;
            this.currentData = null;
            this.searchResultShow = true;
            this.directoryDatas = doc.data.data.directoryList;
            this.imgDatas = doc.data.data.resourceList;
            if (this.directoryDatas.length + this.imgDatas.length == 0) {
              confirmmy(this, {
                title: this.$t("message.未找到图片或目录"),
                iscancel: false,
                isprop: false,
              });
              // this.$message({
              //   type: "warning",
              //   message: this.$t.未找到图片或目录,
              // });
            }
          }
        }
      );
      // this.$http
      //   .get("/manage/resource/search", {
      //     params: {
      //       appid: this.appID,
      //       content: this.searchContent,
      //     },
      //   })
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.parentData = null;
      //       this.currentData = null;
      //       this.searchResultShow = true;
      //       this.directoryDatas = doc.data.data.directoryList;
      //       this.imgDatas = doc.data.data.resourceList;
      //       if (this.directoryDatas.length + this.imgDatas.length == 0) {
      //         this.$message({
      //           type: "warning",
      //           message: "未找到图片或目录",
      //         });
      //       }
      //     }
      //   });
    },
    onMoveTo() {
      if (this.selectedType == null) {
        confirmmy(this, {
          title: this.$t("message.您还未选择任何项目"),
          iscancel: false,
          isprop: false,
        });
        // this.$message({
        //   type: "error",
        //   message: this.$t.您还未选择任何项目,
        // });
        return;
      }
      // 打开移动文件面板
      this.moveToDialogVisible = true;
      this.createTreeData();
    },
    createTreeData() {
      this.treeData = new Array();
      var rootRegion = {
        label: this.$t("message.根目录"),
        value: "0",
        children: [],
      };
      this.treeData.push(rootRegion);
      rejecthttp(
        true,
        "get",
        "/manage/resource/tree",
        {
          appid: this.appID,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.treeServerData = doc.data.data;
            this.treeRecursion("0", rootRegion);
            console.log(this.treeData);
          }
        }
      );
      // this.$http
      //   .get("/manage/resource/tree", {
      //     params: {
      //       appid: this.appID,
      //     },
      //   })
      //   .then((doc) => {
      //     console.log(doc.data)
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.treeServerData = doc.data.data;
      //       this.treeRecursion("0", rootRegion);
      //       console.log(this.treeData);
      //     }
      //   });
    },
    treeRecursion(dirID, target) {
      this.treeServerData.forEach((element) => {
        if (
          this.selectedType == 1 &&
          element.directoryID ==
            this.directoryDatas[this.selectedDIRIndex].directoryID
        ) {
        } else if (target.value == element.parentID) {
          var children = {
            label: element.name,
            value: element.directoryID,
            children: [],
            disabled:
              (this.selectedType == 1 &&
                element.directoryID ==
                  this.directoryDatas[this.selectedDIRIndex].directoryID) ||
              target.disabled
                ? true
                : false,
          };
          target.children.push(children);
          this.treeRecursion(element.directoryID, children);
        }
      });
    },
    handleCheckChangeArea(data) {
      // treeForm.setCheckedKeys([data]); //选中已选中节点
      this.moveToTargetID = data.value;
    },
    doMoveTo() {
      if (this.moveToTargetID == null) {
        confirmmy(this, {
          title: this.$t("message.您还未选择目标路径"),
          iscancel: false,
          isprop: false,
        });
        // this.$message({
        //   type: "warning",
        //   message: this.$t.您还未选择目标路径,
        // });
        return;
      }
      if (this.selectedType == 1) {
        rejecthttp(
          true,
          "post",
          "/manage/resource/movedirectoryto",
          {
            appid: this.appID,
            currentid: this.directoryDatas[this.selectedDIRIndex].directoryID,
            targetdirectoryid: this.moveToTargetID,
          },
          this,
          (doc) => {
            changeflagCLOSED(doc, 0, this);
            if (doc.data.Code == "MSGKEY_OK") {
              this.successMsgBox(doc.data.Message);
              this.openDirectory(
                this.currentData ? this.currentData.directoryID : "0"
              );
            }
          }
        );
        // this.$http
        //   .post("/manage/resource/movedirectoryto", {
        //     appid: this.appID,
        //     currentid: this.directoryDatas[this.selectedDIRIndex].directoryID,
        //     targetdirectoryid: this.moveToTargetID,
        //   })
        //   .then((doc) => {
        //     // console.log(doc.data)
        //     if (doc.data.Code != "MSGKEY_OK") {
        //       this.$message({
        //         type: "error",
        //         message: doc.data.Message,
        //       });
        //     } else {
        //       this.successMsgBox(doc.data.Message);
        //       this.openDirectory(
        //         this.currentData ? this.currentData.directoryID : "0"
        //       );
        //     }
        //   });
      } else if (this.selectedType == 2) {
        rejecthttp(
          true,
          "post",
          "/manage/resource/moveto",
          {
            appid: this.appID,
            currentid: this.imgDatas[this.selectedIMGIndex].resourceID,
            targetdirectoryid: this.moveToTargetID,
          },
          this,
          (doc) => {
            changeflagCLOSED(doc, 0, this);
            if (doc.data.Code == "MSGKEY_OK") {
              this.successMsgBox(doc.data.Message);
              this.openDirectory(
                this.currentData ? this.currentData.directoryID : "0"
              );
            }
          }
        );
        // this.$http
        //   .post("/manage/resource/moveto", {
        //     appid: this.appID,
        //     currentid: this.imgDatas[this.selectedIMGIndex].resourceID,
        //     targetdirectoryid: this.moveToTargetID,
        //   })
        //   .then((doc) => {
        //     if (doc.data.Code != "MSGKEY_OK") {
        //       this.$message({
        //         type: "error",
        //         message: doc.data.Message,
        //       });
        //     } else {
        //       this.successMsgBox(doc.data.Message);
        //       this.openDirectory(
        //         this.currentData ? this.currentData.directoryID : "0"
        //       );
        //     }
        //   });
      }
      this.moveToTargetID = null;
      this.moveToDialogVisible = false;
    },
    onUploadChange(file, fileList) {
      //这里做一些文件控制，注意：就算一次选取多个文件，这里依旧会执行多次
      // const isJPG = file.raw.type === "image/jpeg";
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      //   fileList.pop();
      // }
      // let existFile = fileList
      //   .slice(0, fileList.length - 1)
      //   .find((f) => f.name === file.name);
      // if (existFile) {
      //   this.$message.error("当前文件已经存在!");
      //   fileList.pop();
      // }
      this.fileList = fileList;
    },

    onUploadRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },
  computed: {
    usersRAM() {
      // return 25.66;
      return parseFloat(
        ((this.RAMInfo.usedRam / this.RAMInfo.maxRam) * 100).toFixed(2)
      );
    },
    usedRam() {
      return commonUtil.formatRam(this.RAMInfo.usedRam);
    },
    maxRam() {
      console.log(this.RAMInfo.maxRam);
      return commonUtil.formatRam(this.RAMInfo.maxRam);
    },
    sessionHeaders() {
      return { DMFSession: this.$store.state.token };
    },
  },
  created() {
    this.onLoad();
  },
  mounted() {
    // PopupManager.zIndex = 2000;
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.count-img {
  width: 80px;
  height: 32px;
  position: absolute;
  bottom: 8%;
  color: rgb(240, 240, 240);
  left: 50%;
  margin-left: -40px;
  font-size: 14px;
  border-radius: 30px;
  background-color: rgba(0, 0, 0, 0.4);
  line-height: 32px;
  text-align: center;
}

.myImg {
  position: relative;
  left: 50%;
  top: 50%; /*偏移*/
  transform: translate(-50%, -50%);

  max-width: 70%;
  max-height: 87%;
}

.zheZhao {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  /* z-index: 3009; */
  display: flex;
}
.zheZhao .exit {
  position: absolute;
  top: 10px;
  right: 10px;
  color: rgb(220, 220, 220);
  cursor: pointer;
  font-size: 20px;
}
.zheZhao .content-img {
  margin: auto;
  width: 80%;
  height: 80%;
}

.myDate {
  position: absolute;
  bottom: 9px;
  left: 300px;
}
.myDate p {
  color: #303133;
}

.myObject {
  position: absolute;
  left: 22px;
  bottom: 23px;
  color: #303133;
}

.on-btn {
  position: absolute;
  bottom: 20px;
  right: 30px;
}

.link-btn {
  margin-left: 10px;
}

.resource-title {
  position: absolute;
  top: 15px;
  left: 48px;
  font-size: 18px;
  font-family: "微软雅黑";
  color: #303133;
  font-weight: 600;
}

.resource-icon {
  position: relative;
  top: -7px;
  font-size: 27px;
  color: #303133;
  margin-bottom: 20px;
}

.resource-icon:after {
  position: absolute;
  content: "";
  display: block;
  height: 90%;
  width: 0;
  border-left: 3px solid #303133;
  left: -10px;
  top: 2px;
}

.resource {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  top: 70px;
  width: 100%;
  /* height 505px */
  /* border-top: 1px solid #ddd; */
  /* border-bottom  1px solid #ddd */
}

.seek-box {
  position: absolute;
  width: 330px;
  height: 40px;
  top: -42px;
  right: 0px;
  /* z-index: 10; */
}

.seek-box /deep/ .el-input__inner {
  height: 35px;
}

.seek-main {
  width: 80%;
  height: 40px;
  font-size: 14px;
  color: #888;
  border: none;
}

.seek-icon {
  font-size: 28px;
  cursor: pointer;
  color: #303133;
  position: relative;
  top: 5px;
  margin-left: 0.1em;
}

.progress {
  position: absolute;
  bottom: 20px;
  left: 100px;
  width: 140px;
  cursor: pointer;
}
.progress span {
  color: #303133;
  /* margin-top: 5px; */
  position: relative;
  /* top: 5px; */
}

.progress .progressbar {
  position: absolute;
  /* margin-top: 5px; */
  top: 1px;
  left: 31px;
  width: 160px;
}
.progress /deep/ .el-progress-bar__outer {
  background-color: #b6d6e5;
}

.progress /deep/ .el-progress-bar__innerText {
  color: #303133;
}

a {
  cursor: pointer;
  text-decoration: inherit;
  color: #303133;
  /* font-weight:bold; */
}

a:hover {
  text-decoration: underline;
  color: #b8e025;
}

.fileColor {
  background-color: #a7daf1;
  position: relative;
  /* overflow: hidden; */
}
.fileColor::after{
  content: '\2714';
  display: block;
  position: absolute;
  top: 2px;
  color: skyblue;
  background-color: #fff;
  width:16px;
  text-align: center;
  height: 16px;
  border-radius: 50%;
  right: 2px;
}

.fileImg {
  width: 80px;
  height: 90px;
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  margin-right: 10px;
  align-items: center;
}
.fileImg .imgP {
  margin-top: 6px;
}

.fileImg textarea {
  border: 1px solid #888;
  margin-top: 4px;
}
.fileImg div {
  width: 80px;
  height: 40px;
  text-align: center;
}

.fileImg img {
  max-width: 80px;
  max-height: 40px;
  line-height: 40px;
}

.file {
  margin-bottom: 10px;
  width: 80px;
  height: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
}
.file el-tooltip textarea {
  border: 1px solid #888;
}

.marg-top {
  margin-top: 135px !important;
}

.post-box {
  display: flex;
  position: absolute;
  align-items: center;
  border: 1px solid #ddd;
  top: 35px;
  box-shadow: 1px 1px 5px #eee;
  left: 100px;
  width: 350px;
  height: 100px;
  padding: 20px;
  justify-content: space-around;
  background-color: #fff;
  border-radius: 4px;
}
.post-box .select-label {
  font-size: 14px;
  color: #333;
}

.post-p {
  position: absolute;
  top: 32px;
  left: 0px;
  font-size: 14px;
  color: #333;
}

.fileIcon {
  color: #ffdb67;
  font-size: 49px;
  cursor: pointer;
}

.shade-chil {
  width: 1050px;
  height: 680px;
  /* background-color: RGB(249,249,249); */
  border-radius: 12px;
  box-shadow: 4px 4px 12px #888888;
  background-image: linear-gradient(#f9f9f9, #fdfdfd, #f0f0f0, #f3f3f3);

  border-left: 1px solid #bbb;
  border-top: 1px solid #bbb;
  border-right: 1px solid #888;
  border-bottom: 1px solid #888;
  padding: 20px;
  position: relative;
  /* z-index: 3000; */
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.shade-chil .listBtn-box {
  position: absolute;
  width: 670px;
  height: 30px;
  line-height: 30px;
  /* border-right: 1px solid #ddd; */
  /* border-left   1px solid #ddd */
  padding-left: 10px;
  top: -37px;
  left: 3px;
  /* z-index: 3000; */
}
.shade-chil .listBtn-box span a {
  color: #303133;
  font-size: 10px;
}

.shade-chil .listBtn-box span i {
  color: #303133;
  font-size: 10px;
}

.myipt {
  text-align: center;
  width: 80px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
}

.myiptSelected {
  /* height: 4em; */
  word-wrap: break-word;
  white-space: pre-wrap;
  overflow: visible;
  background-color: #a7daf1;
  /* background-color: rgba(167,218,241,0.2); */
  /* z-index: 3001; */
}

.box {
  width: 600px;
  margin-left: 100px;
}
.box li {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 35px;
}
.box li .label {
  width: 80px;
  font-size: 14px;
  color: #444;
}

.state-box {
  position: absolute;
  top: -73px;
  width: 100%;
  line-height: 30px;
  left: 0px;
  height: 30px;
  display: flex;
  border-bottom: 1px solid #ddd;
  color: #303133;
}

.btnClass {
  width: 88px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  border-radius: 5px;
  color: #fff;
  background-color: #50bfff;
  cursor: pointer;
}

.resourceList {
  width: 100%;
  height: 500px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* align-content: center; */
  align-content: flex-start;
  /* position: relative; */
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding-left: 20px;
}

.renameTextArea {
  position: relative;
  width: 80px;
  resize: none;
  overflow: visible;
  height: auto;
  background-color: #fff;
  /* z-index: 3001; */
}

.renameTextAreaDialog {
  position: relative;
  width: 350px;
  height: 80px;
  resize: none;
  overflow: visible;
  background-color: #fff;
  border: 1px solid #ddd;
  /* z-index: 3001; */
}
</style>



// WEBPACK FOOTER //
// src/components/resourceStore/resourceStore.vue